import React from 'react';
import { useJobSetupStore } from '@presentation/stores/JobSetupStore';
import { JobPipelineTypeSchema } from '@domain/schemas/BI';
import { RadioGroup } from '@progress/kendo-react-inputs';
import { FieldWrapper } from '@progress/kendo-react-form';

export const JobPipelineSelectionBlock: React.FC = () => {
    const { pipelineType, setPipelineType } = useJobSetupStore((state) => ({
        pipelineType: state.CreateJobState.pipelineType,
        setPipelineType: state.setPipelineType,
    }));

    const data = [
        { label: 'directDIA®', value: JobPipelineTypeSchema.DirectDIA },
        { label: 'Library Generation', value: JobPipelineTypeSchema.LibraryGeneration },
        { label: 'Library Based Analysis', value: JobPipelineTypeSchema.LibraryBased },
    ];

    return (
        <fieldset className="k-form-fieldset">
            <legend className="k-form-legend">
                <strong>Pipeline</strong>
            </legend>
            <FieldWrapper>
                <div style={{ marginTop: '-10px'  }}>
                    <RadioGroup
                        data={data}
                        value={pipelineType}    
                        onChange={(e) => setPipelineType(e.value)}
                        layout="horizontal"
                    />
                </div>
            </FieldWrapper>
        </fieldset> 
    );
};
